/** Files for taking away: CSV as Excel opens it (semicolon, UTF-8 with BOM), JSON as it is. */

const cell = (v: unknown) => {
  if (v === null || v === undefined) return "";
  const s = typeof v === "number" ? String(v).replace(".", ",") : String(v);
  return /[;"\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function toCsv(rows: unknown[][]): string {
  return "﻿" + rows.map((r) => r.map(cell).join(";")).join("\r\n") + "\r\n";
}

export function download(name: string, content: string, type: string) {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** "2026-10-15" for file names; dates in the app are local. */
export const today = () => new Date().toLocaleDateString("sv-SE");
/** Euro amount for a CSV cell: cents as a number with comma. */
export const euroCell = (cents: number) => Math.round(cents) / 100;
